<ng-container *ngIf="crwPageData$ | async as crwPageData">
  <app-card-subscription-your *ngIf="crwPageData.currentSubscription" />
  <app-card-subscriptions *ngIf="!crwPageData.currentSubscription" />
</ng-container>
